import type { Stripe } from 'stripe';
import { object, string, boolean, number, union, optional, array, literal } from 'valibot';

export function isActiveProduct(product: Stripe.Price['product']): product is Stripe.Product {
	return typeof product !== 'string' && !product.deleted;
}

const CheckoutPaymentMetaSchema = object({
	userAgent: optional(string()),
	termsOfService: optional(string()),
	afterSubmitText: optional(string()),
	successPage: optional(string()),
	productSubline: optional(string())
});

export const CheckoutPaymentSchema = object({
	productId: string(),
	priceId: string(),
	interval: optional(union([literal('day'), literal('week'), literal('month'), literal('year')])),
	meta: optional(CheckoutPaymentMetaSchema),
	isTrial: optional(boolean()),
	allowedPaymentMethods: optional(
		union([literal('card_only'), literal('affirm_only'), literal('all'), literal('without_affirm')])
	),
	accessCode: optional(string()),
	userLabels: optional(array(string())),
	impactClickId: optional(string()),
	etaWeeks: optional(
		object({
			min: optional(number()),
			max: optional(number())
		})
	),
	shippingId: optional(string()),
	adjustableQuantity: optional(
		object({
			enabled: optional(boolean()),
			max: optional(number())
		})
	)
});

export function getShownRate({ unit_amount, recurring }: Stripe.Price): number {
	if (unit_amount === null) return 0;

	if (recurring?.interval === 'year') return unit_amount / 12;

	return unit_amount;
}
